/** CMS Date is stored as IST calendar midnight; format in Asia/Kolkata so SSR (UTC) matches post hero. */
const BLOG_PUBLICATION_TIME_ZONE = "Asia/Kolkata";

const formatBlogPublicationDate = (dateString: string): string => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: BLOG_PUBLICATION_TIME_ZONE,
  });
};

export default formatBlogPublicationDate;
